export default __webpack_public_path__ + "43dd79c6fcc9b47ad7867f556bbf5fcf.png";